// extracted by mini-css-extract-plugin
export default {"root":"Avatar_root__EXfY-","--sm":"Avatar_--sm__CyOHx","--md":"Avatar_--md__ky633"};